/**
 * Maps legacy icon keys (`mdi-*`) to design-system Vue components.
 * These keys are lookup ids, not stylesheet classes. Not all new icons have a corresponding key.
 */
export default {
    'mdi-account': 'AccountIcon',
    'mdi-account-arrow-left': 'AccountArrowLeftIcon',
    'mdi-account-edit-outline': 'AccountEditOutlineIcon',
    'mdi-account-group': 'AccountGroupIcon',
    'mdi-account-multiple': 'AccountMultipleIcon',
    'mdi-account-plus': 'AccountPlusIcon',
    'mdi-alarm': 'AlarmIcon',
    'mdi-alert': 'AlertIcon',
    'mdi-alert-circle': 'AlertCircleIcon',
    'mdi-alert-circle-outline': 'AlertCircleOutlineIcon',
    'mdi-alert-outline': 'AlertOutlineIcon',
    'mdi-apple': 'AppleIcon',
    'mdi-apps': 'AppsIcon',
    'mdi-archive': 'ArchiveIcon',
    'mdi-arrow-down': 'ArrowDownIcon',
    'mdi-arrow-down-drop-circle': 'ArrowDownDropCircleIcon',
    'mdi-arrow-expand-horizontal': 'ArrowExpandHorizontalIcon',
    'mdi-arrow-left': 'ArrowLeftIcon',
    'mdi-arrow-left-top': 'ArrowLeftTopIcon',
    'mdi-arrow-right': 'ArrowRightIcon',
    'mdi-arrow-right-top': 'ArrowRightTopIcon',
    'mdi-arrow-top-left-thick': 'ArrowTopLeftThickIcon',
    'mdi-arrow-up': 'ArrowUpIcon',
    'mdi-asterisk': 'AsteriskIcon',
    'mdi-at': 'AtIcon',
    'mdi-baby-carriage': 'BabyCarriageIcon',
    'mdi-baby-face': 'BabyFaceIcon',
    'mdi-baby-face-outline': 'BabyFaceOutlineIcon',
    'mdi-balloon': 'BalloonIcon',
    'mdi-bell': 'BellIcon',
    'mdi-book-open-blank-variant': 'BookOpenBlankVariantIcon',
    'mdi-book-open-variant': 'BookOpenVariantIcon',
    'mdi-briefcase': 'BriefcaseIcon',
    'mdi-bullhorn': 'BullhornIcon',
    'mdi-cake-variant': 'CakeVariantIcon',
    'mdi-calendar': 'CalendarIcon',
    'mdi-calendar-blank': 'CalendarBlankIcon',
    'mdi-camera': 'CameraIcon',
    'mdi-camera-account': 'CameraAccountIcon',
    'mdi-card-bulleted-outline': 'CardBulletedOutlineIcon',
    'mdi-cards-heart': 'CardsHeartIcon',
    'mdi-cart-variant': 'CartVariantIcon',
    'mdi-chart-areaspline': 'ChartAreasplineIcon',
    'mdi-chart-bar': 'ChartBarIcon',
    'mdi-chart-box': 'ChartBoxIcon',
    'mdi-chat': 'ChatIcon',
    'mdi-check': 'CheckIcon',
    'mdi-check-bold': 'CheckBoldIcon',
    'mdi-check-circle-outline': 'CheckCircleOutlineIcon',
    'mdi-chevron-down': 'ChevronDownIcon',
    'mdi-chevron-left': 'ChevronLeftIcon',
    'mdi-chevron-right': 'ChevronRightIcon',
    'mdi-chevron-up': 'ChevronUpIcon',
    'mdi-circle-slice-6': 'CircleSlice6Icon',
    'mdi-city': 'CityIcon',
    'mdi-clock-outline': 'ClockOutlineIcon',
    'mdi-close': 'CloseIcon',
    'mdi-close-circle': 'CloseCircleIcon',
    'mdi-close-circle-outline': 'CloseCircleOutlineIcon',
    'mdi-cloud': 'CloudIcon',
    'mdi-cloud-upload': 'CloudUploadIcon',
    'mdi-cog': 'CogIcon',
    'mdi-contacts': 'ContactsIcon',
    'mdi-content-copy': 'ContentCopyIcon',
    'mdi-delete': 'DeleteIcon',
    'mdi-dots-horizontal': 'DotsHorizontalIcon',
    'mdi-download': 'DownloadIcon',
    'mdi-drag': 'DragIcon',
    'mdi-email': 'EmailIcon',
    'mdi-eye': 'EyeIcon',
    'mdi-eye-check': 'EyeCheckIcon',
    'mdi-eye-off': 'EyeOffIcon',
    'mdi-facebook': 'FacebookIcon',
    'mdi-fan': 'FanIcon',
    'mdi-file': 'FileIcon',
    'mdi-file-document-edit': 'FileDocumentEditIcon',
    'mdi-file-document-outline': 'FileDocumentOutlineIcon',
    'mdi-file-excel': 'FileExcelIcon',
    'mdi-file-image': 'FileImageIcon',
    'mdi-file-multiple': 'FileMultipleIcon',
    'mdi-file-pdf': 'FilePdfIcon',
    'mdi-file-powerpoint': 'FilePowerpointIcon',
    'mdi-file-upload': 'FileUploadIcon',
    'mdi-file-word': 'FileWordIcon',
    'mdi-flag': 'FlagIcon',
    'mdi-flag-plus': 'FlagPlusIcon',
    'mdi-folder-image': 'FolderImageIcon',
    'mdi-folder-multiple': 'FolderMultipleIcon',
    'mdi-folder-multiple-image': 'FolderMultipleImageIcon',
    'mdi-food-apple': 'FoodAppleIcon',
    'mdi-fork-and-knife': 'ForkAndKnifeIcon',
    'mdi-format-align-center': 'FormatAlignCenterIcon',
    'mdi-format-align-justify': 'FormatAlignJustifyIcon',
    'mdi-format-align-left': 'FormatAlignLeftIcon',
    'mdi-format-align-right': 'FormatAlignRightIcon',
    'mdi-format-bold': 'FormatBoldIcon',
    'mdi-format-clear': 'FormatClearIcon',
    'mdi-format-color-highlight': 'FormatColorHighlightIcon',
    'mdi-format-color-text': 'FormatColorTextIcon',
    'mdi-format-columns': 'FormatColumnsIcon',
    'mdi-format-header-1': 'FormatHeader1Icon',
    'mdi-format-header-2': 'FormatHeader2Icon',
    'mdi-format-header-3': 'FormatHeader3Icon',
    'mdi-format-italic': 'FormatItalicIcon',
    'mdi-format-list-bulleted': 'FormatListBulletedIcon',
    'mdi-format-list-group-plus': 'FormatListGroupPlusIcon',
    'mdi-format-list-numbered': 'FormatListNumberedIcon',
    'mdi-format-pilcrow': 'FormatPilcrowIcon',
    'mdi-format-quote-close': 'FormatQuoteCloseIcon',
    'mdi-format-strikethrough': 'FormatStrikethroughIcon',
    'mdi-format-strikethrough-variant': 'FormatStrikethroughVariantIcon',
    'mdi-format-underline': 'FormatUnderlineIcon',
    'mdi-forum': 'ForumIcon',
    'mdi-forward': 'ForwardIcon',
    'mdi-forward-arrow': 'ForwardArrowIcon',
    'mdi-gift': 'GiftIcon',
    'mdi-gnome': 'GnomeIcon',
    'mdi-google': 'GoogleIcon',
    'mdi-hand': 'HandIcon',
    'mdi-heart': 'HeartIcon',
    'mdi-heart-outline': 'HeartOutlineIcon',
    'mdi-help': 'HelpIcon',
    'mdi-help-circle-outline': 'HelpCircleOutlineIcon',
    'mdi-history': 'HistoryIcon',
    'mdi-home': 'HomeIcon',
    'mdi-image': 'ImageIcon',
    'mdi-image-edit': 'ImageEditIcon',
    'mdi-image-plus': 'ImagePlusIcon',
    'mdi-information-outline': 'InformationOutlineIcon',
    'mdi-information-variant': 'InformationVariantIcon',
    'mdi-key-vertical': 'KeyVerticalIcon',
    'mdi-language-swift': 'LanguageSwiftIcon',
    'mdi-lead-pencil': 'LeadPencilIcon',
    'mdi-lifebuoy': 'LifebuoyIcon',
    'mdi-lightbulb-on': 'LightbulbOnIcon',
    'mdi-link': 'LinkIcon',
    'mdi-link-off': 'LinkOffIcon',
    'mdi-link-variant-plus': 'LinkVariantPlusIcon',
    'mdi-local-shipping': 'LocalShippingIcon',
    'mdi-lock': 'LockIcon',
    'mdi-lock-outline': 'LockOutlineIcon',
    'mdi-magnify': 'MagnifyIcon',
    'mdi-map-marker': 'MapMarkerIcon',
    'mdi-message-outline': 'MessageOutlineIcon',
    'mdi-message-plus': 'MessagePlusIcon',
    'mdi-message-text': 'MessageTextIcon',
    'mdi-minus': 'MinusIcon',
    'mdi-music-note-eighth': 'MusicNoteEighthIcon',
    'mdi-nature': 'NatureIcon',
    'mdi-nut': 'NutIcon',
    'mdi-palm-tree': 'PalmTreeIcon',
    'mdi-panda': 'PandaIcon',
    'mdi-paperclip': 'PaperclipIcon',
    'mdi-pencil-lock': 'PencilLockIcon',
    'mdi-pencil-plus': 'PencilPlusIcon',
    'mdi-pentagon': 'PentagonIcon',
    'mdi-person': 'PersonIcon',
    'mdi-person-off': 'PersonOffIcon',
    'mdi-phone': 'PhoneIcon',
    'mdi-pig': 'PigIcon',
    'mdi-plan-open': 'PlanOpenIcon',
    'mdi-play': 'PlayIcon',
    'mdi-play-circle-outline': 'PlayCircleOutlineIcon',
    'mdi-plus': 'PlusIcon',
    'mdi-plus-thick': 'PlusThickIcon',
    'mdi-printer': 'PrinterIcon',
    'mdi-redo': 'RedoIcon',
    'mdi-refresh': 'RefreshIcon',
    'mdi-refresh-circle': 'RefreshCircleIcon',
    'mdi-reply': 'ReplyIcon',
    'mdi-reply-all': 'ReplyAllIcon',
    'mdi-restore': 'RestoreIcon',
    'mdi-rhombus-split': 'RhombusSplitIcon',
    'mdi-rotate-left': 'RotateLeftIcon',
    'mdi-rotate-right': 'RotateRightIcon',
    'mdi-shape': 'ShapeIcon',
    'mdi-ship-wheel': 'ShipWheelIcon',
    'mdi-silverware': 'SilverwareIcon',
    'mdi-sort': 'SortIcon',
    'mdi-spa': 'SpaIcon',
    'mdi-star-face': 'StarFaceIcon',
    'mdi-star-outline': 'StarOutlineIcon',
    'mdi-stop': 'StopIcon',
    'mdi-storefront': 'StorefrontIcon',
    'mdi-table': 'TableIcon',
    'mdi-table-column-plus-after': 'TableColumnPlusAfterIcon',
    'mdi-table-column-plus-before': 'TableColumnPlusBeforeIcon',
    'mdi-table-column-remove': 'TableColumnRemoveIcon',
    'mdi-table-large': 'TableLargeIcon',
    'mdi-table-merge-cells': 'TableMergeCellsIcon',
    'mdi-table-plus': 'TablePlusIcon',
    'mdi-table-remove': 'TableRemoveIcon',
    'mdi-table-row-plus-after': 'TableRowPlusAfterIcon',
    'mdi-table-row-plus-before': 'TableRowPlusBeforeIcon',
    'mdi-table-row-remove': 'TableRowRemoveIcon',
    'mdi-text-box-check': 'TextBoxCheckIcon',
    'mdi-text-box-plus': 'TextBoxPlusIcon',
    'mdi-thumb-up': 'ThumbUpIcon',
    'mdi-tooth': 'ToothIcon',
    'mdi-trash-can': 'TrashCanIcon',
    'mdi-trash-can-outline': 'TrashCanOutlineIcon',
    'mdi-undo': 'UndoIcon',
    'mdi-undo-variant': 'UndoVariantIcon',
    'mdi-user-comment': 'UserCommentIcon',
    'mdi-view-dashboard': 'ViewDashboardIcon',
    'mdi-view-list': 'ViewListIcon',
    'mdi-web': 'WebIcon',
    'mdi-web-sync': 'WebSyncIcon',
    'mdi-white-balance-sunny': 'WhiteBalanceSunnyIcon',
    'mdi-sync-alt': 'SyncAltIcon'
};
